import { CurrencyEnum } from '../../../../../../../lib/graphql'
import { divideByFactor } from '../../../../../../../utils/prices'

export const formatMoney = ({
  value,
  currency,
  options,
}: {
  value: string | number | null | undefined
  currency: CurrencyEnum
  options?: { applyFactor?: boolean; hideDecimals?: boolean }
}): string | undefined => {
  if (value === null || value === undefined || isNaN(Number(value))) {
    return 'N.A'
  } else {
    const baseValue = typeof value === 'number' ? value : Number(value)

    return (
      options?.applyFactor ? divideByFactor(baseValue) : baseValue
    ).toLocaleString(mapCurrencyToLocale(currency), {
      style: 'currency',
      currency: currency,
      ...(options?.hideDecimals && { maximumFractionDigits: 0 }),
    })
  }
}

const mapCurrencyToLocale = (
  currency: CurrencyEnum,
): 'fr-FR' | 'fr-CH' | 'en-GB' => {
  switch (currency) {
    case CurrencyEnum.EUR:
      return 'fr-FR'
    case CurrencyEnum.CHF:
      return 'fr-CH'
    case CurrencyEnum.GBP:
      return 'en-GB'
    default:
      return 'fr-FR'
  }
}
